<template>
    <li class="validation-row">
        <span class="validation-status" v-if="errors && errors.includes(code)">
            <span class="validation-error"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22ZM8.96965 8.96967C9.26254 8.67678 9.73742 8.67678 10.0303 8.96967L12 10.9394L13.9696 8.96969C14.2625 8.6768 14.7374 8.6768 15.0303 8.96969C15.3232 9.26258 15.3232 9.73746 15.0303 10.0303L13.0606 12L15.0303 13.9697C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73744 15.3232 9.26256 15.3232 8.96967 15.0303C8.67678 14.7374 8.67678 14.2626 8.96967 13.9697L10.9393 12L8.96965 10.0303C8.67676 9.73744 8.67676 9.26256 8.96965 8.96967Z" fill="#dc3545"></path> </g></svg></span>
        </span>
        <span class="validation-status" v-else>
            <span class="validation-ok"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z" fill="#28a745"></path> </g></svg></span>
        </span>
        <span class="validation-name">{{$t('password_validation.name.'+code)}}<span class="validation-hint" v-if="validation_hints[code]">{{ validation_hints[code] }}</span></span>
    </li>
</template>

<script>
import { ref } from 'vue'

export default {
    props: ['code', 'errors'],
    setup() {
        const validation_hints = ref({
            "require_special": "!#%/(){}[]=*><@$_-.,;:"
        })
        return {
            validation_hints
        }
    }
}
</script>

<style>
li.validation-row {
    display: flex;
    justify-content: flex-start;
    margin-top: 0;
    gap: 5px;
}

li.validation-row .validation-status {
    font-weight: bold;
}

li.validation-row .validation-status span {
    display: block;
    width: 1.5em;
}

li.validation-row .validation-error {
    color: #e76c6c;
}

li.validation-row .validation-ok {
    color: #88bb66;
}

li.validation-row .validation-hint {
    color: #666;
    padding-left: 15px;
}

li.validation-row .validation-name {
    margin-top: 0.15em;
}
</style>